import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import OrderDashboardLayout from "./Layout/OrderDashboardLayout.jsx";
import PnoInTimeGraph from "./TablesAndGraphs/ByFilter/PnoInTimeGraph.jsx";
import OrdersInTimeGraph from "./TablesAndGraphs/ByFilter/OrdersInTimeGraph.jsx";
import PnoPanel from "./TablesAndGraphs/ByFilter/PnoPanel.jsx";
import * as PropTypes from "prop-types";
import ChannelGrid from "../MarketingChannelGrids/ChannelGrid.jsx";
import {GridType} from "../MarketingChannelGrids/channelGridColumnSetup.js";
import {FilterContext} from "../../../components/filters/DashboardFilterContextProvider.jsx";
import {ErpCalculationApi} from "../../../api/authority/generated/index";
import useAuthorityConfiguration from "../../../api/utilities/useAuthorityConfiguration.js";
import {useErrorTranslation} from "../../../api/utilities/translateErrorMessage.js";
import toast from "react-hot-toast";

export default function OrderMarketingChannelOverview({project}) {

    let {t} = useTranslation();
    let {et} = useErrorTranslation();
    let authorityConfiguration = useAuthorityConfiguration();

    let {since, until, centresAllowListed, domainsAllowListed} = useContext(FilterContext);
    let sinceKey = since.format('YYYY-MM-DD');
    let untilKey = until.format('YYYY-MM-DD');

    let [topGraphsHidden, setTopGraphsHidden] = useState(true);
    let [data, setData] = useState(null);

    useEffect(() => {
        let active = true;
        setData(null);

        new ErpCalculationApi(authorityConfiguration)
            .reportingLegacyCampaignPerformance({
                projectId: project.id,
                erpFilter: {
                    since: sinceKey,
                    until: untilKey,
                    selectedCentreIds: centresAllowListed ?? [],
                    selectedDomainIds: domainsAllowListed ?? [],
                },
            })
            .then((nextData) => {
                if (active) {
                    setData(nextData);
                }
            })
            .catch((e) => {
                if (active) {
                    et(e).then((message) => { if (message) toast.error(message); });
                }
            });

        return () => {
            active = false;
        };
    }, [project.id, sinceKey, untilKey, centresAllowListed, domainsAllowListed]);

    // noinspection JSValidateTypes
    return <OrderDashboardLayout title={t('route.campaign-performance')} showMarketingFilters={true}>

        <PnoInTimeGraph
            project={project}
            defaultHidden={true}
            hidden={topGraphsHidden}
            setHidden={setTopGraphsHidden}
            showHideButton={true}
            data={data?.pno ?? null}
        />

        <OrdersInTimeGraph
            project={project}
            defaultHidden={true}
            hidden={topGraphsHidden}
            setHidden={setTopGraphsHidden}
            showHideButton={true}
            data={data?.orders ?? null}
        />

        <PnoPanel project={project} halfSize={true} compositionData={data?.summary ?? null}/>
        <ChannelGrid project={project} gridType={GridType.MarketingOrders} collection={data?.channels ?? null}/>
    </OrderDashboardLayout>;
}
